import type { Bout } from '../types';

/** The two corners of a bout. */
export type BoutCornerColour = 'red' | 'blue';

/** The facts of one corner of a bout row: the same fields for the red and
 *  the blue corner. The bout page and both ring screens read a corner through
 *  this function, so the `red_` and `blue_` prefix is written once (#661). */
export function boutCorner(b: Bout, corner: BoutCornerColour) {
  return corner === 'red'
    ? {
        last: b.red_last_name, first: b.red_first_name, team: b.red_team_name, country: b.red_country,
        photo: b.red_photo, athleteRecordId: b.red_athlete_record_id,
        gender: b.red_gender, age: b.red_age, weight: b.red_weight,
        experience: b.red_experience, experienceEstimated: b.red_experience_estimated,
      }
    : {
        last: b.blue_last_name, first: b.blue_first_name, team: b.blue_team_name, country: b.blue_country,
        photo: b.blue_photo, athleteRecordId: b.blue_athlete_record_id,
        gender: b.blue_gender, age: b.blue_age, weight: b.blue_weight,
        experience: b.blue_experience, experienceEstimated: b.blue_experience_estimated,
      };
}
